<template>
  <div class="contain-inside">
    <QuestionMatrixOption 
      :item="question_asked" 
      class="mt-8"
      :editable="true"
      @selected="selected_option"
      @edit_clicked="edit_clicked"
    />
  </div>
</template>

<script>
import QuestionMatrixOption from '@/view/components/questions/QuestionMatrixOption.vue';

export default {
  name: 'WebBuilderSurveyMatrix',
  components: {
    QuestionMatrixOption,
  },
  emits: ['edit_clicked'],
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  data() { 
    return {
      question_asked: {
        header: 'Choose an option',
        name: 'Matrix question',
        rows: ['Fråga 1', 'Fråga 2', 'Fråga 3'],
        columns: [
          { label: 'Option 1' },
          { label: 'Option 2' },
          { label: 'Option 3' },
          { label: 'Option 4' },

        ]
      },
    }
  },
  methods: {

    edit_clicked(part, index) {
      this.$emit('edit_clicked', part, index);
    },
    selected_option(selected) {},
  }
};
</script>
